import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';

import { FrontendHeaderComponent } from './frontend-header.component';
import { LocationSwitcherModule } from '@tablesready/frontend-location-switcher';
import { HeaderTitleService } from './header-title.service';
import { ThemeSwitchModule } from '@tablesready/frontend-theme-switch';
import { StatusModule } from '@tablesready/frontend-status-bar';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';
import { SidebarModule } from '@tablesready/frontend-nav-sidebar';
import { FrontendTripleDotsModule } from '@tablesready/frontend-triple-dots';

@NgModule({
  declarations: [FrontendHeaderComponent],
  imports: [
    CommonModule,
    IonicModule,
    ThemeSwitchModule,
    LocationSwitcherModule,
    StatusModule,
    AlertsModule,
    SidebarModule,
    FrontendTripleDotsModule,
  ],
  exports: [
    FrontendHeaderComponent,
  ],
  providers: [HeaderTitleService],
})
export class FrontendHeaderModule { }
